import store from "@/store";
import { CLEAR_ERRORMSG } from "@/store/action-types";
import type { AxiosResponse, AxiosError } from "axios";
import { handleError } from "../errorHandlers/errorHandler";

/**
 * Response interceptor to handle successful responses and errors
 */
export const responseInterceptor = {
  onFulfilled: (response: AxiosResponse): AxiosResponse => {
    store.dispatch(CLEAR_ERRORMSG);
    return response;
  },
  onRejected: (error: AxiosError) => {
    return handleError(error);
  },
};
